import { Field } from 'react-final-form';
import Error from '../../components/Error';
import { Integrations } from '../../types/settings';
import ConfigurationForm from './ConfigurationForm';

interface Props {
    configuration: Integrations;
    onSave: (configuration: Integrations) => void;
    onDelete: () => Promise<void>;
}

export default function PayPalConfiguration({ configuration, onSave, onDelete }: Props) {
    return (
        <ConfigurationForm<Integrations>
            initialValues={configuration}
            name="PayPal Integration"
            onSave={onSave}
            onDelete={onDelete}
            render={() => (
                <div className={'mb-8 pt-8 text-left'}>
                    <div className="mb-2">
                        <label className="text-sm text-gray-600">Sandbox ClientId</label>
                        <Field name={'paypal.testClientId'} component="input" type="text">
                            {({ input, meta }) => (
                                <>
                                    <input {...input} placeholder="" className="input w-full" autoComplete="off" />
                                    {meta.error && (
                                        <span className="ml-2">
                                            <Error message={meta.error} />
                                        </span>
                                    )}
                                </>
                            )}
                        </Field>
                    </div>
                    <div className="mb-2">
                        <label className="text-sm text-gray-600">Live ClientId</label>
                        <Field name={'paypal.liveClientId'} component="input" type="text">
                            {({ input, meta }) => (
                                <>
                                    <input {...input} placeholder="" className="input w-full" autoComplete="off" />
                                    {meta.error && (
                                        <span className="ml-2">
                                            <Error message={meta.error} />
                                        </span>
                                    )}
                                </>
                            )}
                        </Field>
                    </div>
                </div>
            )}
        />
    );
}
